
const cloudFrontUrl = 'https://d922n9wr9eyza.cloudfront.net'
export const getLatestIncident = async () => {
  const response = await fetch(`${cloudFrontUrl}/incident.json`);
  return response.json();
}